import React, { Component } from 'react';
import { Animate } from 'react-simple-animate';
import Job from './job.jsx';
import JobsTableColumnToggler from './jobs-table-column-toggler.jsx';
export default class JobsTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      jobs: props.jobs || [],
      isLoading: !props.jobs,
      url: props.url || null,
      error: false,
      hasMore: true,
      page: 1,
      hideJobsOn: false,
      hideJobsBy: false,
      hideJobsFrom: false,
      hideJobsQ: true,
      infiniteScroll: props.infiniteScroll || false,
      noCategoryLabels: props.noCategoryLabels || false,
      play: false,
      driverScreen: props.driverScreen || false,
      jobIds: props.jobIds || [],
      seprateLoading: false,
      isZoneJobsLoading: false,
      firstSelectedZone: null,
      secondSelectedZone: null,
      firstZoneJobs: [],
      secondZoneJobs: [],
      totalSelectedZone: 0,
      groupWorkScreen: props.groupWorkScreen || false,
      allOtherJobs: false,
      allJobsCurrentPage: 1,
      firstZoneJobsCurrentPage: 1,
      secondZoneJobsCurrentPage: 1,
      customerAllJobsPage: props.customerAllJobsPage || false,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.handler = this.handler.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
  }
  componentWillMount() {
    if (this.state.infiniteScroll === true) {
      window.addEventListener(
        'scroll',
        this.handleScroll
      );
    }
  }
  handler(someValue) {
    this.setState({
      jobs: someValue
    });
  }
  handleLoading(someVal) {
    this.setState({
      seprateLoading: someVal
    });
  }
  componentDidMount() {
    this.setState({
      uuid: this.makeUUID(),
      play: true
    });
    if (this.state.isLoading === true) {
      this.getJobs();
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      jobs: nextProps.jobs,
      jobIds: nextProps.jobIds
    });
  }
  componentWillUnmount() {
    if (this.state.infiniteScroll === true) {
      window.removeEventListener(
        'scroll',
        this.handleScroll
      );
    }
  }
  skipDuplicateApiCall() {
    if (this.state.page === this.state.temp_page) {
      return false;
    } else {
      this.setState({ temp_page: this.state.page });
    }
    return true;
  }


  getJobs() {
    if ((this.state.isLoading === true) && this.state.url) {

      if (this.skipDuplicateApiCall()) {

        return fetch(
          this.state.url + '?page=' + this.state.page,
          {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
              "Authorization": 'Bearer ' + window.api_token,
              "Accept": 'application/json'
            },
          }
        ).then((responseText) => {
          let response = responseText.json();

          response.then((nextJobs) => {
            if (nextJobs.data.length == 0) {
              this.setState({ hasMore: false });
            }
            this.setState({
              isLoading: false,
              jobs: [
                ...this.state.jobs,
                ...nextJobs.data,
              ],
              url: this.state.url,
              page: nextJobs.current_page + 1
            });
          });
        });

      }

    }
    return false;
  }
  makeUUID() {
    let date = new Date().getTime();
    if (typeof performance !== 'undefined' &&
      typeof performance.now === 'function') {
      date += performance.now();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
      function (c) {
        let random = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (
          c === 'x' ?
            random :
            (random & 0x3 | 0x8)).toString(
              16
            );
      }
    );
  }
  handleScroll() {
    /*if ((window.innerHeight + document.documentElement.scrollTop
    ) === document.documentElement.offsetHeight) {*/
    if ((window.innerHeight + document.scrollingElement.scrollTop + 10
    ) >= document.documentElement.offsetHeight) {
      if (this.state.hasMore) {
        this.setState({
          isLoading: true
        });
        this.getJobs();
      }
    }
  }
  handleZoneButtonClick(e) {
    var currentElement = e.target;
    let zonenumber = currentElement.getAttribute('data-zone-number');
    if (this.state.allOtherJobs) {
      this.setState({
        allOtherJobs: false,
        allJobsCurrentPage: 1,
        firstZoneJobs: [],
        secondZoneJobs: [],
      });
    }
    if ((this.state.totalSelectedZone < 3)) {
      $(currentElement).toggleClass('selected');
      if ($(currentElement).hasClass('selected')) {
        if (this.state.firstSelectedZone == null) {
          this.setState({ firstSelectedZone: zonenumber }, () => {
            this.setState({ totalSelectedZone: (this.state.totalSelectedZone + 1) }, () => {
              this.handleFetchFirstZoneJobs();
            });
          });
          if (this.state.secondSelectedZone != null) {
            for (var i = 1; i <= 15; i++) {
              if (!document.querySelector('.zone' + i).classList.contains("selected")) {
                document.querySelector('.zone' + i).style.opacity = '0.7';
                document.querySelector('.zone' + i).disabled = true;
              }
            }
          }
        } else {
          if (this.state.secondSelectedZone == null) {
            this.setState({ secondSelectedZone: zonenumber }, () => {
              this.setState({ totalSelectedZone: (this.state.totalSelectedZone + 1) }, () => {
                this.handleFetchSecondZoneJobs();
              });
            });
            for (var i = 1; i <= 15; i++) {
              if (!document.querySelector('.zone' + i).classList.contains("selected")) {
                document.querySelector('.zone' + i).style.opacity = '0.7';
                document.querySelector('.zone' + i).disabled = true;
              }
            }
          } else {
            currentElement.disabled = false;
            $(currentElement).removeClass('selected');
          }
        }
      } else {
        for (var i = 1; i <= 15; i++) {
          if (document.querySelector('.zone' + i).disabled == true) {
            document.querySelector('.zone' + i).disabled = false;
            document.querySelector('.zone' + i).style.opacity = '1';
          }
        }
        this.setState({ totalSelectedZone: (this.state.totalSelectedZone - 1) });
        if (this.state.firstSelectedZone == zonenumber) {
          this.setState({ firstSelectedZone: null, firstZoneJobs: [], firstZoneJobsCurrentPage: 1 })
        }
        if (this.state.secondSelectedZone == zonenumber) {
          this.setState({ secondSelectedZone: null, secondZoneJobs: [], secondZoneJobsCurrentPage: 1 })
        }
      }
    }

  }
  handleFetchFirstZoneJobs() {
    let selectedFZone = this.state.firstSelectedZone;
    if (this.state.firstZoneJobsCurrentPage == 1) {
      this.setState({ isZoneJobsLoading: true });
    }
    let url = '/api/v1/portal/jobs/get-jobs-by-seleced-zone/' + selectedFZone + '?page=' + this.state.firstZoneJobsCurrentPage;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((nextJobs) => {
        if (nextJobs.data.length == 0) {
          this.setState({ firstZoneJobs: this.state.firstZoneJobs, isZoneJobsLoading: false });
          if (document.querySelector('.load-more-first-btn')) {
            document.querySelector('.load-more-first-btn').innerText = 'No more jobs found..';
          }
        }
        if (nextJobs.data.length > 0) {
          if (document.querySelector('.load-more-first-btn')) {
            document.querySelector('.load-more-first-btn').innerText = 'Load more';
          }
          this.setState({
            isZoneJobsLoading: false,
            firstZoneJobs: [
              ...this.state.firstZoneJobs,
              ...nextJobs.data,
            ],
            firstZoneJobsCurrentPage: nextJobs.current_page + 1
          });
        }
      });
    });
  }
  handleFetchSecondZoneJobs(e) {
    let selectedSZone = this.state.secondSelectedZone;
    if (this.state.secondZoneJobsCurrentPage == 1) {
      this.setState({ isZoneJobsLoading: true });
    }
    let url = '/api/v1/portal/jobs/get-jobs-by-seleced-zone/' + selectedSZone + '?page=' + this.state.secondZoneJobsCurrentPage;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((nextJobs) => {

        if (nextJobs.data.length == 0) {
          this.setState({ secondZoneJobs: this.state.secondZoneJobs, isZoneJobsLoading: false });
          if (document.querySelector('.load-more-second-btn')) {
            document.querySelector('.load-more-second-btn').innerText = 'No more jobs found..';
          }
        }
        if (nextJobs.data.length > 0) {
          if (document.querySelector('.load-more-second-btn')) {
            document.querySelector('.load-more-second-btn').innerText = 'Load more';
          }
          this.setState({
            isZoneJobsLoading: false,
            secondZoneJobs: [
              ...this.state.secondZoneJobs,
              ...nextJobs.data,
            ],
            secondZoneJobsCurrentPage: nextJobs.current_page + 1
          });
        }
      });
    });
  }
  handleAllOtherJobsClick(e) {
    if (this.state.allJobsCurrentPage < 2 && (this.state.firstSelectedZone != null || this.state.secondSelectedZone != null)) {
      /* clean up zone button and zoen filtered jobs */
      this.setState({
        firstSelectedZone: null,
        secondSelectedZone: null,
        firstZoneJobs: [],
        secondZoneJobs: [],
        totalSelectedZone: 0,
        firstZoneJobsCurrentPage: 1,
        secondZoneJobsCurrentPage: 1
      });
      var btns = document.getElementsByClassName('zone-btn');
      for (var i = 0; i < btns.length; i++) {
        btns[i].disabled = false;
        btns[i].style.opacity = '1';
        if ($(btns).hasClass('selected')) {
          $(btns).removeClass('selected');
        }
      }
    }
    /* clean up zone button and zoen filtered jobs */
    //this.setState({isZoneJobsLoading:true});
    let url = '/api/v1/portal/jobs/get-jobs-by-seleced-zone/all' + '?page=' + this.state.allJobsCurrentPage;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((nextJobs) => {
        if (nextJobs.data.length == 0) {
          console.log('no more jobs');
          if (document.querySelector('.load-more-all-btn')) {
            document.querySelector('.load-more-all-btn').innerText = 'No more jobs found..';
          }
        }
        if (nextJobs.data.length > 0) {
          if (document.querySelector('.load-more-all-btn')) {
            document.querySelector('.load-more-all-btn').innerText = 'Load more Jobs';
          }
          this.setState({
            //isZoneJobsLoading: false,
            allOtherJobs: true,
            firstZoneJobs: [
              ...this.state.firstZoneJobs,
              ...nextJobs.data,
            ],
            allJobsCurrentPage: nextJobs.current_page + 1
          });
          if (this.state.allJobsCurrentPage > 2) {
            var elmnt = document.querySelector('.load-more-all-btn');
            elmnt.scrollIntoView();
          }
        }
      });
    });
  }

  resetZoneJobs(e) {
    this.setState({
      firstSelectedZone: null,
      secondSelectedZone: null,
      firstZoneJobs: [],
      secondZoneJobs: [],
      allOtherJobs: false,
      totalSelectedZone: 0,
      allJobsCurrentPage: 1,
      firstZoneJobsCurrentPage: 1,
      secondZoneJobsCurrentPage: 1
    });
    var btns = document.getElementsByClassName('zone-btn');
    for (var i = 0; i < btns.length; i++) {
      btns[i].disabled = false;
      btns[i].style.opacity = '1';
      if ($(btns).hasClass('selected')) {
        $(btns).removeClass('selected');
      }
    }
  }
  handleRegButtonClick(e, currentJobId) {
    this.setState({ zonePageSelectedJobToAddRegNote: currentJobId });
    $('#' + currentJobId + '-add-reg-note').toggleClass('toggle-hide');
  }
  handleHideRegNoteBox() {
    $('#' + this.state.zonePageSelectedJobToAddRegNote + '-add-reg-note').toggleClass('toggle-hide');
  }
  render() {
    let currentPage = window.location.pathname;
    let driverScreen = this.state.driverScreen;
    let groupWorkScreen = this.state.groupWorkScreen;
    let handlerFunc = this.handler;
    let handleLoadingFunc = this.handleLoading;
    let jobIds = this.state.jobIds;
    let uuid = this.state.uuid;
    let apiUrl = this.state.url;
    let JobsBy = [], JobsOn = [], JobsFrom = [], JobsQ = [], displayedJobs = [];
    let customerAllJobsPage = this.state.customerAllJobsPage;
    let isQuote = this.props.is_quote || false;
    let isQuoteRejected = this.props.is_quote_rejected || false;
    if (this.state.jobs && this.state.jobs.length > 0) {

      // this loop puts the jobs in groups of dropoff preposition,
      //  prioritising scheduled over requested,
      //   showing requested only if no value for scheduled.
      let indexCounter = 0;
      let jobsToSort = this.state.jobs;
      if (!isQuote && !isQuoteRejected) {
        jobsToSort = jobsToSort.sort((a, b) => Date.parse(b.required_dropoff_date) < Date.parse(a.required_dropoff_date) ? 1 : -1);
      }

      jobsToSort.forEach(function (i) {
        if (isQuote || isQuoteRejected) {
          JobsBy.push(
            <Job
              key={'job-' + i.id}
              data={i}
              url={apiUrl}
              driverScreen={driverScreen}
              jobIndex={indexCounter}
              handler={handlerFunc}
              handleLoading={handleLoadingFunc}
              jobIds={jobIds}
              is_quote={isQuote}
              is_quote_rejected={isQuoteRejected}
              groupWorkScreen={groupWorkScreen}
              customerAllJobsPage={customerAllJobsPage}
            />
          );
          displayedJobs[i.id] = i.id;
          indexCounter++;
          return;
        }
        // if ((i.scheduled_dropoff_preposition === 'by') &&
        //   (!displayedJobs[i.id])) {
        //   JobsBy.push(
        //     <Job
        //       key={'job-'+i.id}
        //       data={i}
        //       url={apiUrl}
        //       driverScreen={driverScreen}
        //       jobIndex={indexCounter}
        //       handler={handlerFunc}
        //       handleLoading={handleLoadingFunc}
        //       jobIds={jobIds}
        //       groupWorkScreen={groupWorkScreen}        
        //     />
        //   );
        //   displayedJobs[i.id] = i.id;
        //   indexCounter++;
        // }
        // if ((i.scheduled_dropoff_preposition === 'on') &&
        //   (!displayedJobs[i.id])) {
        //   JobsOn.push(
        //     <Job
        //       key={'job-'+i.id}
        //       data={i}
        //       url={apiUrl}
        //       driverScreen={driverScreen}
        //       jobIndex={indexCounter}
        //       handler={handlerFunc}
        //       handleLoading={handleLoadingFunc}
        //       jobIds={jobIds}
        //       groupWorkScreen={groupWorkScreen}        
        //     />
        //   );
        //   displayedJobs[i.id] = i.id;
        //   indexCounter++;
        // }
        // if ((i.scheduled_dropoff_preposition === 'from') &&
        //   (!displayedJobs[i.id])) {
        //   JobsFrom.push(
        //     <Job
        //       key={'job-'+i.id}
        //       data={i}
        //       url={apiUrl}
        //       driverScreen={driverScreen}
        //       jobIndex={indexCounter}
        //       handler={handlerFunc}
        //       handleLoading={handleLoadingFunc}
        //       jobIds={jobIds}
        //       groupWorkScreen={groupWorkScreen}        
        //     />
        //   );
        //   displayedJobs[i.id] = i.id;
        //   indexCounter++;
        // }
        // if ((i.scheduled_dropoff_preposition === '?') &&
        //   (!displayedJobs[i.id])) {
        //   JobsQ.push(
        //     <Job
        //       key={'job-'+i.id}
        //       data={i}
        //       url={apiUrl}
        //       driverScreen={driverScreen}
        //       jobIndex={indexCounter}
        //       handler={handlerFunc}
        //       handleLoading={handleLoadingFunc}
        //       jobIds={jobIds}
        //       groupWorkScreen={groupWorkScreen}        
        //     />
        //   );
        //   displayedJobs[i.id] = i.id;
        //   indexCounter++;
        // }
        // if ((i.dropoff_preposition === 'by') &&
        //   (!displayedJobs[i.id])) {
        //   JobsBy.push(
        //     <Job
        //       key={'job-'+i.id}
        //       data={i}
        //       url={apiUrl}
        //       driverScreen={driverScreen}
        //       jobIndex={indexCounter}
        //       handler={handlerFunc}
        //       handleLoading={handleLoadingFunc}
        //       jobIds={jobIds}
        //       groupWorkScreen={groupWorkScreen}        
        //     />
        //   );
        //   displayedJobs[i.id] = i.id;
        //   indexCounter++;
        // }
        // if ((i.dropoff_preposition === 'on') &&
        //   (!displayedJobs[i.id])) {
        //   JobsOn.push(
        //     <Job
        //       key={'job-'+i.id}
        //       data={i}
        //       url={apiUrl}
        //       driverScreen={driverScreen}
        //       jobIndex={indexCounter}
        //       handler={handlerFunc}
        //       handleLoading={handleLoadingFunc}
        //       jobIds={jobIds}
        //       groupWorkScreen={groupWorkScreen}        
        //     />
        //   );
        //   displayedJobs[i.id] = i.id;
        //   indexCounter++;
        // }
        // if ((i.dropoff_preposition === 'from') &&
        //   (!displayedJobs[i.id])) {
        //   JobsFrom.push(
        //     <Job
        //       key={'job-'+i.id}
        //       data={i}
        //       url={apiUrl}
        //       driverScreen={driverScreen}
        //       jobIndex={indexCounter}
        //       handler={handlerFunc}
        //       handleLoading={handleLoadingFunc}
        //       jobIds={jobIds}
        //       groupWorkScreen={groupWorkScreen}        
        //     />
        //   );
        //   displayedJobs[i.id] = i.id;
        //   indexCounter++;
        // }
        // if ((i.dropoff_preposition === '?') &&
        //   (!displayedJobs[i.id])) {
        //   JobsQ.push(
        //     <Job
        //       key={'job-'+i.id}
        //       data={i}
        //       url={apiUrl}
        //       driverScreen={driverScreen}
        //       jobIndex={indexCounter}
        //       handler={handlerFunc}
        //       handleLoading={handleLoadingFunc}
        //       jobIds={jobIds}
        //       groupWorkScreen={groupWorkScreen}        
        //     />
        //   );
        //   displayedJobs[i.id] = i.id;
        //   indexCounter++;
        // }

        JobsFrom.push(
          <Job
            key={'job-' + i.id}
            data={i}
            url={apiUrl}
            driverScreen={driverScreen}
            jobIndex={indexCounter}
            handler={handlerFunc}
            handleLoading={handleLoadingFunc}
            jobIds={jobIds}
            is_quote={isQuote}
            is_quote_rejected={isQuoteRejected}
            groupWorkScreen={groupWorkScreen}
            customerAllJobsPage={customerAllJobsPage}
          />
        );
        displayedJobs[i.id] = i.id;
        indexCounter++;
      });
    }
    let firstZoneJobs = [];
    let secondZoneJobs = [];
    if (this.state.firstZoneJobs.length > 0) {
      this.state.firstZoneJobs.map((currentJob, index) => {
        let joburl = "/jobs/view/" + currentJob.id;
        firstZoneJobs.push(
          <tr key={index}>
            <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
            <td>{currentJob.pickup_day}/{currentJob.pickup_month}/{currentJob.pickup_year} {currentJob.pickup_time.toUpperCase()}</td>
            <td>{currentJob.unit != null ? currentJob.unit.unit_number : ""}</td>
            <td data-toggle="tooltip" data-placement="right" data-original-title={currentJob.reg_note} className={(currentJob.reg_note) ? "user-click-event yellow-bg" : "user-click-event"}>
              <span onClick={(e) => this.handleRegButtonClick(e, jobDShowHideId)}>
                {(currentJob.vehicle != null) && ((currentJob.vehicle).registration_number != null) ? currentJob.vehicle.registration_number : currentJob.vehicle.vin_number}
              </span>
            </td>
            <td>{currentJob.customer.name}</td>
            <td>{currentJob.pickup_address.town_city}</td>
            <td>{currentJob.pickup_address.postcode}</td>
            <td>{currentJob.dropoff_address.town_city}</td>
            <td>{currentJob.dropoff_address.postcode}</td>
          </tr>
        );
      });
    } else {
      firstZoneJobs.push(
        <tr key='no-records'><td colSpan="8" className='text-center'>No Records</td></tr>
      );
    }
    if (this.state.secondZoneJobs.length > 0) {
      this.state.secondZoneJobs.map((currentJob, index) => {
        let joburl = "/jobs/view/" + currentJob.id;
        secondZoneJobs.push(
          <tr key={index}>
            <td className="job-ref-font16"><a href={joburl}>{currentJob.id}</a></td>
            <td>{currentJob.pickup_day}/{currentJob.pickup_month}/{currentJob.pickup_year} {currentJob.pickup_time.toUpperCase()}</td>
            <td>{currentJob.unit != null ? currentJob.unit.unit_number : ""}</td>
            <td>{currentJob.customer.name}</td>
            <td>{currentJob.pickup_address.town_city}</td>
            <td>{currentJob.pickup_address.postcode}</td>
            <td>{currentJob.dropoff_address.town_city}</td>
            <td>{currentJob.dropoff_address.postcode}</td>
          </tr>
        );
      });
    } else {
      secondZoneJobs.push(
        <tr key='no-records'><td colSpan="8" className='text-center'>No Records</td></tr>
      );
    }
    return (
      <>
        {groupWorkScreen ?
          <div className="zone-jobs-container">
            <div className="row align-cenetered">
              <div className="col-md-3">
                <img src="/images/Map-New.jpg" className="img-responsive" />
              </div>
              <div className="col-md-9">
                <div className="row">
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone1 btn-lg" data-zone-number="1" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone2 btn-lg" data-zone-number="2" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone3 btn-lg" data-zone-number="3" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone4 btn-lg" data-zone-number="4" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone5 btn-lg" data-zone-number="5" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone6 btn-lg" data-zone-number="6" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone7 btn-lg" data-zone-number="7" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone8 btn-lg" data-zone-number="8" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone9 btn-lg" data-zone-number="9" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone10 btn-lg" data-zone-number="10" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone11 btn-lg" data-zone-number="11" onClick={(e) => this.handleZoneButtonClick(e)}>

                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone12 btn-lg" data-zone-number="12" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone13 btn-lg" data-zone-number="13" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone14 btn-lg" data-zone-number="14" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zone15  btn-lg" data-zone-number="15" onClick={(e) => this.handleZoneButtonClick(e)}>
                    </button>
                  </div>
                  <div className="col-md-2">
                    <button className="alert alert-info zone-btn zoneOther btn-lg" onClick={(e) => this.handleAllOtherJobsClick(e)}></button>
                  </div>
                </div>
              </div>
            </div>
          </div> : ''}
        {(this.state.firstZoneJobs.length > 0 || this.state.secondZoneJobs.length > 0) ?
          <div className="row">
            <div className="col-md-12 text-center"><a className="btn btn-link back-to-job-listing" onClick={(e) => this.resetZoneJobs(e)}><i className="fa fa-arrow-left"></i>  Back to job listing</a></div>
            <div className={(this.state.allOtherJobs) ? 'col-md-12' : 'col-md-12'}>
              {this.state.allOtherJobs ?
                <h2 className="text-center">All Jobs</h2> :
                <h2 className="text-center">ZONE {this.state.firstSelectedZone}</h2>
              }
              <table className="table table-bordered black-bordered-table">
                <thead>
                  <tr>
                    <th>Job Number</th>
                    <th>Required Pickup</th>
                    <th>Unit Number</th>
                    <th>Customer</th>
                    <th>Pickup Town/city</th>
                    <th>Pickup Postcode</th>
                    <th>Dropoff Town/city</th>
                    <th>Dropoff Postcode</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.isZoneJobsLoading ?
                    (<tr><td colSpan="8"><span className="add-loading-text">
                      <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                    firstZoneJobs
                  }
                </tbody>
              </table>
              {!this.state.allOtherJobs ?
                <button className="alert alert-success btn-block load-more-first-btn" title="Load more jobs" onClick={(e) => this.handleFetchFirstZoneJobs(e)}>Load more</button>
                : ''}
              {this.state.allOtherJobs ?
                <button className="alert alert-success btn-block load-more-all-btn" title="Load more jobs" onClick={(e) => this.handleAllOtherJobsClick(e)}>Load more Jobs</button>
                : ''}

              <br />
            </div>
            {!this.state.allOtherJobs ?
              <div className="col-md-12">
                <h2 className="text-center">ZONE {this.state.secondSelectedZone}</h2>
                <table className="table table-bordered black-bordered-table">
                  <thead>
                    <tr>
                      <th>Job Number</th>
                      <th>Required Pickup</th>
                      <th>Unit Number</th>
                      <th>Customer</th>
                      <th>Pickup Town/city</th>
                      <th>Pickup Postcode</th>
                      <th>Dropoff Town/city</th>
                      <th>Dropoff Postcode</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.isZoneJobsLoading ?
                      (<tr><td colSpan="8"><span className="add-loading-text">
                        <i className="fa fa-spinner fa-pulse"></i></span></td></tr>) :
                      secondZoneJobs
                    }
                  </tbody>
                </table>
                {!this.state.allOtherJobs ?
                  <button className="alert alert-success btn-block load-more-second-btn" title="Load more jobs" onClick={(e) => this.handleFetchSecondZoneJobs(e)}>Load more</button>
                  : ''}
                <br />
              </div> : ''
            }
          </div>
          :
          <div className="jobs-table" key={uuid + '-table'}>
            {this.state.seprateLoading ?
              <div className="seprate-loading text-center">
                <h1><i className="fa fa-spinner fa-pulse"></i></h1>
              </div>
              :
              ''
            }
            <JobsTableColumnToggler />
            <Animate play={this.state.play} start={{ opacity: 0 }} end={{ opacity: 1 }} key={uuid + '-animate'}>
              {!groupWorkScreen ?
                <div className="jobs-table-row header jobs-table-header-row">
                  {this.state.driverScreen ?
                    <div className="cell column-type-order">
                      MOVE
                    </div> : ''
                  }
                  <div className="cell column-type-job-number">
                    Job Number
                  </div>
                  <div className="cell column-type-company">
                    Company
                  </div>
                  {/* <div className="cell column-type-original-company">
              Original Company
            </div> */}
                  {/* <div className="cell column-type-subcontracted-by-company">
              Subcontracted By
            </div> */}
                  {/* <div className="cell column-type-subcontracted-to-company">
              Subcontracted To
            </div> */}
                  <div className="cell column-type-required-dropoff">
                    Required Service
                  </div>
                  <div className="cell column-type-required-pickup">
                    Following Service Date
                  </div>
                  <div className="cell column-type-scheduled-pickup">
                    Scheduled Pickup
                  </div>
                  <div className="cell column-type-scheduled-dropoff">
                    Scheduled Dropoff
                  </div>
                  <div className="cell column-type-reg">
                    Total Units
                  </div>
                  <div className="cell column-unit-hired-term">
                    Unit Term
                  </div>
                  <div className="cell column-type-of-unit">
                    Type Of Service
                  </div>
                  <div className="cell column-three-little-words">
                    3 Little Words
                  </div>
                  <div className="cell column-notes">
                    Notes
                  </div>
                  <div className="cell column-type-vehicle-on-site">
                    Vehicle On Site
                  </div>
                  <div className="cell column-type-customer">
                    Customer
                  </div>
                  <div className="cell column-type-pickup-from">
                    Pickup From
                  </div>
                  <div className="cell column-type-pickup-postcode">
                    Pickup Postcode
                  </div>
                  <div className="cell column-type-pickup-town-city">
                    Pickup Town/City
                  </div>
                  <div className="cell column-type-reg_note">
                    Date of event
                  </div>
                  {
                    (['/jobs/unplanned', '/jobs/delivered', '/drivers/schedules', '/jobs/all', '/quotes', '/rejected-quotes'].includes(currentPage) || currentPage.startsWith('/jobs/customer/')) && (
                      <div className="cell column-type-c_note">
                        Offhired Note
                      </div>
                    )
                  }
                  <div className="cell column-type-dropoff-to">
                    Service To
                  </div>
                  <div className="cell column-type-dropoff-address">
                    Service Address
                  </div>
                  <div className="cell column-type-dropoff-town-city">
                    Service Town/City
                  </div>
                  <div className="cell column-type-dropoff-postcode">
                    Service Postcode
                  </div>
                  <div className="cell column-type-driver">
                    Driver
                  </div>
                  <div className="cell column-type-status">
                    Driver Status
                  </div>
                  <div className="cell column-type-distance-in-miles">
                    Miles
                  </div>
                  <div className="cell column-type-estimated-duration">
                    Estimated Duration
                  </div>
                  <div className="cell column-type-job-price">
                    Job Price
                  </div>
                  <div className="cell column-type-driver-price">
                    Driver Price
                  </div>
                  {/* <div className="cell column-type-expenses-price">
              Expenses Price
            </div> */}
                  <div className="cell column-type-gross-profit-percentage">
                    Gross Profit (%)
                  </div>
                  <div className="cell column-type-invoice-month">
                    Invoice Month
                  </div>
                  <div className="cell column-type-invoice-number">
                    Invoice Number
                  </div>
                  <div className="cell column-type-job-type">
                    Job Option
                  </div>
                  <div className="cell column-type-driver-delivered-date">
                    Driver Delivered Date
                  </div>
                  <div className="cell column-type-hire-only-weeks">
                    Hire Only Weeks
                  </div>
                  <div className="cell column-type-hire-only-week-cost">
                    Hire Only Week Cost
                  </div>
                  <div className="cell column-type-delivery-cost">
                    Delivery Cost
                  </div>
                  <div className="cell column-type-collection-cost">
                    Collection Cost
                  </div>
                  {(
                    this.props.is_quote === true ||
                    this.props.is_quote_rejected === true
                  ) && (
                      <>
                        <div className="cell column-type-job-quoted-at">
                          Quote At
                        </div>
                        <div className="cell column-type-job-quoted-action">
                          Quote Action
                        </div>
                      </>
                    )}
                  {/* <div className="cell column-type-confirmed_on_site">
              Confirmed on site
            </div> */}
                  <div className="cell column-type-full-details">
                    &nbsp;
                  </div>
                </div>
                : ''}
            </Animate>
            {(JobsBy.length > 0 && !this.state.groupWorkScreen) ?
              [
                <div
                  className="jobs-table-divider-heading"
                  key={"jobs-table-subtitle-by-" + uuid}
                  style={{
                    display: (
                      this.state.noCategoryLabels === true ?
                        'none' :
                        'block'
                    )
                  }}
                >
                  {(isQuote || isQuoteRejected) ? 'QUOTES' : 'DROPOFFS BY'}
                </div>
              ].concat(
                <div
                  key={'jobs-table-all-jobs-by-' + uuid}
                >
                  {JobsBy}
                </div>
              )
              : null
            }
            {(JobsOn.length > 0) ?
              [
                <div
                  className="jobs-table-divider-heading"
                  key={"jobs-table-subtitle-on-" + uuid}
                  style={{
                    display: (
                      this.state.noCategoryLabels === true ?
                        'none' :
                        'block'
                    )
                  }}
                >
                  DROPOFFS ON
                </div>
              ].concat(
                <div
                  key={'jobs-table-all-jobs-on-' + uuid}
                >
                  {JobsOn}
                </div>
              )
              : null
            }
            {(JobsFrom.length > 0) ?
              [
                <div
                  className="jobs-table-divider-heading"
                  key={"jobs-table-subtitle-from-" + uuid}
                  style={{
                    display: (
                      this.state.noCategoryLabels === true ?
                        'none' :
                        'block'
                    )
                  }}
                >
                  DROPOFFS FROM
                </div>
              ].concat(
                <div
                  key={'jobs-table-all-from-' + uuid}
                >
                  {JobsFrom}
                </div>
              )
              : null
            }
            {(JobsQ.length > 0) ?
              [
                <div
                  className="jobs-table-divider-heading"
                  key={"jobs-table-subtitle-q-" + uuid}
                  style={{
                    display: (
                      this.state.noCategoryLabels === true ?
                        'none' :
                        'block'
                    )
                  }}
                >
                  DROPOFFS ?
                </div>
              ].concat(
                <div
                  key={"jobs-table-all-q-" + uuid}
                >
                  {JobsQ}
                </div>
              )
              : null
            }
          </div>
        }
        {(this.state.isLoading) ?
          <div className="text-center">
            <h1>
              <i className="fa fa-spinner fa-pulse"></i>
            </h1>
          </div>
          :
          null
        }{(this.state.hasMore) ?
          null
          :
          <div className="text-center no-more">
            <h1>
              No more jobs.
            </h1>
          </div>
        }
      </>
    );
  }
}
